import { useMutation, useQueryClient } from 'react-query';
import axiosInstance from '../../config/axiosInstance';
import { UpdateOrderStatusInput } from '../../config/types/custom/UpdateOrderStatusInput';
import { urls } from '../../config/urls';

export const useChangeProductStatus = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (data: UpdateOrderStatusInput) =>
      axiosInstance
        .post(`${urls.orders.updateStatus}`, data)
        .then((res) => res.data),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(['order', data.id]);
      },
    }
  );
};

export const useSaveCategory = () => {};
